import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import {
  EmployeeStandardCellView,
  EmployeeStandardOverridesState,
  EmployeeStandardSelectableUser
} from '../../../../../../models/employee-standard-overrides.model';
import { EmployeeStandardOverridesBackdropService } from '../services/employee-standard-overrides-backdrop.service';
import { EmployeeStandardOverridesBulkRequestBuilder } from '../services/employee-standard-overrides-bulk-request.builder';
import { EmployeeStandardOverridesFacade } from '../services/employee-standard-overrides.facade';
import { EmployeeStandardOverridesMapper } from '../services/employee-standard-overrides.mapper';
import { EmployeeStandardOverridesNotificationService } from '../services/employee-standard-overrides-notification.service';

const EMPLOYEE_STANDARD_STEP_SELECT = 'SELECT';
const EMPLOYEE_STANDARD_STEP_MATRIX = 'MATRIX';

@Component({
  selector: 'app-employee-standard-overrides-modal',
  templateUrl: './employee-standard-overrides-modal.component.html',
  styleUrls: ['./employee-standard-overrides-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    EmployeeStandardOverridesFacade,
    EmployeeStandardOverridesMapper,
    EmployeeStandardOverridesBulkRequestBuilder,
    EmployeeStandardOverridesNotificationService,
    EmployeeStandardOverridesBackdropService
  ]
})
export class EmployeeStandardOverridesModalComponent implements OnInit, OnDestroy {
  @Input() public groupId = '';
  public readonly state$: Observable<EmployeeStandardOverridesState>;
  public readonly selectionStep = EMPLOYEE_STANDARD_STEP_SELECT;
  public readonly matrixStep = EMPLOYEE_STANDARD_STEP_MATRIX;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly facade: EmployeeStandardOverridesFacade,
    private readonly backdropService: EmployeeStandardOverridesBackdropService
  ) {
    this.state$ = this.facade.state$;
  }

  public ngOnInit(): void {
    this.backdropService.add();
    this.facade.initialize(this.groupId);
  }

  public ngOnDestroy(): void {
    this.backdropService.remove();
    this.facade.destroy();
  }

  public onClose(): void {
    this.activeModal.dismiss();
  }

  public onToggleUser(user: EmployeeStandardSelectableUser): void {
    this.facade.toggleUser(user);
  }

  public onOpenMatrix(): void {
    this.facade.openMatrix();
  }

  public onOpenSelection(): void {
    this.facade.openSelection();
  }

  public onToggleCell(cell: EmployeeStandardCellView): void {
    this.facade.toggleCell(cell);
  }

  public onSaveChanges(): void {
    this.facade.saveChanges();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/employee-standard-overrides/employee-standard-overrides-modal/employee-standard-overrides-modal.component.ts